import { IEvent, IHost } from "@Interfaces";
import {
    PAYMENT_DEBIT_MODES,
    PAYMENT_DEBIT_MODES_LABEL,
} from "repoV2/features/Payments/Payments.constants";
import { isAutoDebitActiveOnMainListingData } from "repoV2/features/Listing/Listing.utils";
import { getPlanData } from "../../utils/plan";
import { IContentHeader } from "./IContentHeader";

export const getContentHeaderProps = ({
    host,
    eventData,
    planId,
    isMobile,
}: {
    host: IHost.IStore;
    eventData: IEvent.IEventData;
    planId?: string;
    isMobile: boolean;
}): IContentHeader.IBaseProps => {
    const planData = getPlanData({ host, planId });

    const {
        variantsData,
        selectedVariant,
        currency,
        offering_variation_short_description,
        selectedOfferingVariation,
    } = eventData;
    let variantShortDescription;
    if (variantsData?.variants)
        variantShortDescription = selectedVariant
            ? `${currency} ${selectedVariant?.price_per_head}`
            : " ";
    const isAutoDebitActiveOnMainListing =
        isAutoDebitActiveOnMainListingData(eventData);

    let shortDescription = eventData?.short_description || "";
    if (variantShortDescription) {
        shortDescription = variantShortDescription;
    } else if (planData?.short_description) {
        shortDescription = planData?.short_description;
    } else if (
        offering_variation_short_description &&
        !selectedOfferingVariation
    ) {
        shortDescription = offering_variation_short_description;
    } else if (selectedOfferingVariation) {
        shortDescription =
            selectedOfferingVariation?.short_description || shortDescription;
    }

    let title = eventData?.title || "";
    if (planData?.title) {
        title = planData?.title;
    } else if (selectedOfferingVariation) {
        title = `${title} - ${selectedOfferingVariation.title}`;
    }

    return {
        isMobile,
        title,
        shortDescription,
        ...(isAutoDebitActiveOnMainListing && {
            paymentPlanType:
                PAYMENT_DEBIT_MODES_LABEL[PAYMENT_DEBIT_MODES.AUTO_DEBIT],
        }),
        showEventMedia: isMobile,
    };
};
